












































































































































































































































import {Component, Vue, Watch} from 'vue-property-decorator';
import {Action, Getter} from 'vuex-class';
import {ErrorHelper, LoggingHelper, LogLevel} from 'core-helpers';
import {CoreInputValidators} from 'core-input-validators';
import moment from 'moment';
import SlotsService from '@/services/SlotsService';
import Message from '@/models/Message';
import {ActionTypes as ActionTypesQueue, GetterTypes as GetterTypesQueue} from '../../../store/queues/types';
import {ActionTypes as ActionTypesSnackbar} from '../../../store/snackbar/types';
import QueueList from '../../../components/QueueList/QueueList.vue';
import Queue from '../../../models/Queue';

const queueNamespace: string = 'queue';
const snackbarNamespace: string = 'snackbar';

@Component({
  components: {QueueList}
})
export default class QueuesManagement extends Vue {
  @Action(ActionTypesQueue.FETCH_QUEUES, {namespace: queueNamespace}) fetchQueues!: () => Promise<void>;
  @Action(ActionTypesQueue.SELECT_QUEUE, {namespace: queueNamespace}) selectQueue!: (queue: Queue | null) => void;
  @Action(ActionTypesQueue.CLEAR_SELECTED_QUEUE, {namespace: queueNamespace}) clearSelectedQueue!: () => void;
  @Action(ActionTypesQueue.REMOVE_SLOT, {namespace: queueNamespace}) removeSlot!: (slotUuid: string) => void;
  @Action(ActionTypesQueue.MERGE_TO_QUEUE, {namespace: queueNamespace}) mergeToQueue!: (queue: Queue) => void;
  @Getter(GetterTypesQueue.GET_QUEUES, {namespace: queueNamespace}) queues!: Queue[];
  @Getter(GetterTypesQueue.GET_QUEUE, {namespace: queueNamespace}) queue!: Queue | undefined;

  @Action(ActionTypesSnackbar.SHOW, {namespace: snackbarNamespace}) showSnackbar!: (message: Message) => void;

  @Getter(GetterTypesQueue.GET_IS_LOADING, {namespace: queueNamespace}) isQueueActionLoading!: boolean;

  private selectedQueueUuid: string = '';
  private queuesSelectorLabel = this.$t('global.loading');
  private queueListLoading = false;

  // Generate slots form
  private startDate: string = moment().startOf('day').format('yyyy-MM-DD');
  private endDate: string = moment().startOf('day').add(7, 'days').format('yyyy-MM-DD');
  private slotDuration: number = 5; // In minutes
  private slotBreakDuration: number = 0; // In minutes
  private startTime: string = '7:30';
  private endTime: string = '15:30';
  private isGenerateSlotsFormValid = true;
  private skipWeekends = true;

  // Date pickers
  private startDatePickerVisibility = false;
  private slotsStartDateMinimum = moment().startOf('day').format('yyyy-MM-DD');
  private endDatePickerVisibility = false;
  private slotsEndDateMaximum = moment().startOf('day').add(1, 'month').format('yyyy-MM-DD');

  // Time pickers
  private timePickersMinTime = '7:00';
  private timePickersMaxTime = '20:00';
  private startTimePickedVisibility = false;
  private endTimePickedVisibility = false;

  // Overlays
  private generatingSlotsOverlayVisible = false;

  // Error holders
  private errorMessage: string = '';
  private startDateErrors = [];
  private endDateErrors = [];
  private startHourErrors = [];
  private hoursErrors = [];
  private otherErrors = [];

  private slotsStartDateRules = [(v: any) => CoreInputValidators.required(v)];
  private slotsEndDateRules = [(v: any) => CoreInputValidators.required(v)];

  private slotsDurationRules = [
    (v: any) => CoreInputValidators.isNumberRule(v),
    (v: number) => CoreInputValidators.minRule(Number(v), 5, true),
    (v: number) => CoreInputValidators.maxRule(Number(v), 60, true)
  ];

  private slotsBreakRules = [
    (v: any) => CoreInputValidators.isNumberRule(v),
    (v: number) => CoreInputValidators.minRule(Number(v), 0, true),
    (v: number) => CoreInputValidators.maxRule(Number(v), 60, true)
  ];

  private slotEndTimeRules = [
    (v: any) => CoreInputValidators.required(v)
    // (v: any) => {
    //   const startDate = moment(`${this.startDate}T${this.startTime}`);
    //   const endDate = moment(`${this.endDate}T${v}`);
    //   const duration = moment.duration(endDate.diff(startDate));
    //
    //   return duration.asMinutes() >= 60;
    // }
  ];

  get rowToColumnBreakpoint(): boolean {
    switch (this.$vuetify.breakpoint.name) {
      case 'xs':
      case 'sm':
        return true;
      case 'md':
      case 'lg':
      case 'xl':
        return false;
      default:
        return false;
    }
  }

  @Watch('startDate')
  private onStartDateChange(): void {
    const startDate = moment(this.startDate.replace('.', '-'));
    const endDate = moment(this.endDate.replace('.', '-'));

    if (startDate > endDate) {
      this.endDate = startDate.format('yyyy-MM-DD');
    }
  }

  private async mounted(): Promise<void> {
    this.clearSelectedQueue();
    await this.getQueues();
  }

  private beforeDestroy() {
    this.selectedQueueUuid = '';
  }

  private getQueueByUuid(uuid: string): Queue | undefined {
    return this.queues.find((queue: Queue) => queue.uuid === uuid);
  }

  private async getQueues(): Promise<void> {
    this.queueListLoading = true;

    try {
      await this.fetchQueues();

      this.queuesSelectorLabel = this.$t('admin.queues-report.queue-selector');

      if (this.queues.length) {
        this.selectedQueueUuid = this.queues[0].uuid;
        await this.updateSelectedQueue();
      }
    } catch (err: unknown) {
      LoggingHelper.log(err, LogLevel.ERROR);
    }

    this.queueListLoading = false;
  }

  private async updateSelectedQueue(): Promise<void> {
    try {
      const queue = this.getQueueByUuid(this.selectedQueueUuid);

      if (queue) {
        this.selectQueue(queue);
      }
    } catch (err: unknown) {
      LoggingHelper.log(err, LogLevel.ERROR);
    }
  }

  private async onDeleteSlotEvent(slotUuid: string): Promise<void> {
    try {
      const response = await SlotsService.deleteSlot(slotUuid);

      if (response === 'ok') {
        this.removeSlot(slotUuid);
      }
    } catch (err: unknown) {
      try {
        const axiosError = ErrorHelper.getAxiosError(err);

        if (axiosError && axiosError.data.data) {
          this.showSnackbar({message: axiosError.data.data[0], color: 'error'});
        }
      } catch (e: unknown) {
        LoggingHelper.log(e, LogLevel.ERROR);
      }
    }
  }

  private async generateSlots(): Promise<void> {
    this.errorMessage = '';
    this.startDateErrors = [];
    this.endDateErrors = [];
    this.startHourErrors = [];
    this.hoursErrors = [];
    this.otherErrors = [];

    if (!this.isGenerateSlotsFormValid) {
      console.log('form invalid!');
      return;
    }

    this.generatingSlotsOverlayVisible = true;

    const startDate = moment(this.startDate.replace('.', '-')).unix();
    const endDateTimestamp = moment(this.endDate.replace('.', '-')).unix();

    try {
      const response = await SlotsService.generateBatchOfSlots(
          this.selectedQueueUuid,
          startDate,
          endDateTimestamp,
          Number(this.startTime.split(':')[0]),
          Number(this.startTime.split(':')[1]),
          Number(this.endTime.split(':')[0]),
          Number(this.endTime.split(':')[1]),
          Number(this.slotDuration),
          Number(this.slotBreakDuration),
          this.skipWeekends
      );

      this.mergeToQueue(response);
      this.selectQueue(response);
    } catch (err: unknown) {
      try {
        const axiosError = ErrorHelper.getAxiosError(err);

        if (axiosError) {
          if (axiosError.data.message && axiosError.status !== 409) {
            this.errorMessage = axiosError.data.message;
          }

          if (axiosError.data.data) {
            const errors = axiosError.data.data;

            if (errors.startDate) {
              this.startDateErrors = errors.startDate;
            }

            if (errors.endDate) {
              this.endDateErrors = errors.endDate;
            }

            if (errors.startHour) {
              this.startHourErrors = errors.startHour;
            }

            if (errors.hours) {
              this.hoursErrors = errors.hours;
            }

            if (errors.other) {
              this.otherErrors = errors.other;
            }
          }
        }
      } catch (e: unknown) {
        LoggingHelper.log(e, LogLevel.ERROR);
      }
    }

    this.generatingSlotsOverlayVisible = false;
  }

  get expandMoreOptions() : number {
    if (this.queue && this.queue.days){
      // 0 = more options expanded, other numbers means it's contracted
      return this.queue.days.length > 0 ? 1 : 0;
    }

    return 1;
  }
}
